import React from 'react';
import { Box } from '@common-fe/common-fe';

interface Props {
  children?: React.ReactNode;
}

const DocumentPageWrapper: React.FC<Props> = ({ children }) => (
  <Box style={{ aspectRatio: '2 / 3' }} justify="center" align="center" background="canvas">
    {children}
  </Box>
);

export default DocumentPageWrapper;
